<script setup lang="ts">
import {defineProps, getCurrentInstance} from 'vue';
import Room from "@/models/Room";
import {useStore} from 'vuex';

const props = defineProps<{ roomItem: Room }>()
const baseUri = process.env.VUE_APP_API_ASSET_URL;
const commodities = props.roomItem?.room_spec
    ? props.roomItem?.room_spec?.split(',') : [];
const {$router} = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
console.log("-*************test room properties**************");
console.log(props.roomItem.room_name)
const getRoomDetails = () => {
  store.dispatch('room/saveRoomChoose', props.roomItem)
  $router.push(`/apartment/${props.roomItem.id}/details`)
}
</script>

<template>
  <li><!-- room item #2 -->
    <div class="impx-room-item medium uk-box-shadow-large">
      <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-grid" data-uk-grid="">
        <div class="uk-card-media-left uk-cover-container uk-position-relative uk-first-column">
          <canvas width="290" height="180"></canvas>
          <img :src="roomItem?.room_photos?.[0] ? baseUri + roomItem.room_photos[0] : ''" alt="" data-uk-cover=""
               class="uk-cover" style="width: 340px; height: 340px;">
          <div class="impx-overlay light overlay-squared padding-xwide"></div>
        </div>
        <div class="uk-card-body uk-position-relative impx-padding-medium">
          <div class="uk-card-header uk-padding-remove-horizontal">
            <h4 class="uk-card-title uk-margin-remove-bottom">{{ roomItem.room_name }}</h4>
            <p class="uk-text-meta uk-margin-remove-top">{{ roomItem?.room_type?.room_type_name ?? '' }}</p>
          </div>
          <span class="uk-card-badge uk-label bg-color-csa uk-text-bold ">{{ roomItem.room_total_price }} /nuitée</span>
          <ul class="uk-list room-fac">
            <li v-for="(commod, index) in commodities.slice(0, 3)" :key="index">
              <span class="impx-text-aqua uk-icon" data-uk-icon="icon: check; ratio: 1;">
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <polyline fill="none" stroke="#000" stroke-width="1.1"
                                                                          points="4,10 8,15 17,4"></polyline></svg>
              </span>
              {{ commod }}
            </li>
          </ul>

          <div class="uk-card-footer uk-padding-remove-horizontal uk-padding-remove-bottom">
            <button class="uk-button  uk-button-text impx-text-csa btn-outline" @click="getRoomDetails()">Détails
            </button>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<style scoped>
.btn-outline {
  border: 1px solid #D62F2F;
  border-radius: 3rem;
  padding: 0.4rem;
  width: 5rem;
}
</style>